<template>
  <el-dialog
    :title="title ? title : '视频播放'"
    :visible.sync="playVisible1"
    width="800px"
    height="600px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :before-close="handleClose"
    footer="false">
    <!--    <iframe src="../../static/ol_play_old.html?sf=PC" height="530px" width="760px" frameborder="0" scrolling="no"></iframe>-->
    <div :class="fullShow ? 'videoBox' : ''" v-if="srcNew">
      <video ref="video" :src="srcNew" :width="width" :height="height" autoplay @timeupdate="timeupdate"></video>
      <el-progress :percentage="percentage1" :format="format"></el-progress>
      <el-button @click="playClick" v-if="!play">播放</el-button>
      <el-button @click="playClick" v-if="play">暂停</el-button>
      <el-button @click="seekClick(10)">快进10秒</el-button>
      <el-button @click="seekClick(20)">快进20秒</el-button>
      <el-button @click="seekClick(-20)">快退20秒</el-button>
      <el-button @click="seekClick(-10)">快退10秒</el-button>
      <el-button v-if="!fullShow" @click="openClick">全屏</el-button>
      <el-button v-if="fullShow" @click="openClick">退出全屏</el-button>
    </div>
    <div v-else class="noVideo">视频未加载</div>
  </el-dialog>
</template>

<script>
import {mapMutations, mapState} from 'vuex'

export default {
  name: 'openPlay',
  props: ['src', 'title'],
  computed: {
    ...mapState(['playVisible', 'jurisdictionVideo'])
  },
  data () {
    return {
      playVisible1: false,
      width: '760px',
      height: '500px',
      play: true,
      percentage1: 0,
      percentage: '00:00 / 00:00',
      // 判断是否是全屏
      fullShow: false,
      srcNew: ''
    }
  },
  mounted () {

  },
  methods: {
    ...mapMutations(['setPlayVisible', 'setJurisdictionVideo']),
    handleClose () {
      let that = this
      that.setPlayVisible(false)
      that.playVisible1 = false
      that.srcNew = ''
    },
    // 当目前的播放位置已更改时
    timeupdate (e) {
      this.$nextTick(() => {
        this.getPercentage()
      })
    },
    playClick () {
      this.play = !this.play
      if (this.play) {
        this.$refs.video.play()
      } else {
        this.$refs.video.pause()
      }
    },
    seekClick (val) {
      this.getPercentage()
      this.$refs.video.currentTime = this.$refs.video.currentTime + val
    },
    getPercentage () {
      if (this.$refs.video) {
        this.percentage1 = parseInt(this.$refs.video.currentTime / this.$refs.video.duration * 100)
        this.percentage = this.timer(this.$refs.video.currentTime) + '/' + this.timer(this.$refs.video.duration)
      }
    },
    format () {
      return this.percentage
    },
    // 时间格式化
    timer (seconds) {
      let minute = Math.floor(seconds / 60)
      if (minute < 10) {
        minute = '0' + minute
      }
      let second = Math.floor(seconds % 60)
      if (second < 10) {
        second = '0' + second
      }
      return minute + ':' + second
    },
    // 全屏和退出全屏
    openClick () {
      this.fullShow = !this.fullShow
      if (this.fullShow) {
        this.width = window.innerWidth - 20
        this.height = window.innerHeight - 80
      } else {
        this.width = '760px'
        this.height = '500px'
      }
    },
    //  获取视频播放连接
    getPlayUrl (src) {
      let that = this
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/oss/view',
        params: {
          url: src
        }
      }).then((result) => {
        if (result.data.code === 0) {
          that.playVisible1 = true
          that.srcNew = result.data.data.viewPath
        }
      })
    }
  },
  watch: {
    playVisible (val) {
      if (val === true) {
        if (!sessionStorage.getItem('token')) {
          this.$confirm('您还未登录，请先登录后查看视频', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.setPlayVisible(false)
            sessionStorage.removeItem('token')
            this.$router.push('/login')
          }).catch(() => {
            this.setPlayVisible(false)
          })
        } else {
          this.getPlayUrl(this.src)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.videoBox{
  position: fixed;
  top: 0px;
  left: 0px;
  background: #ffffff;
  padding: 10px;
  width: 100%;
}
.noVideo{
  width: 100%;
  height: 300px;
  text-align: center;
  line-height: 300px;
}
.testBox{
  width: 100%;
  text-align: center;
}
.img-box{
  width: 100%;
  height: 100%;
  #qrCode{
    width: 120px;
    height: 120px;
    margin: 20px auto;
  }
}
</style>
<style>
.el-progress-bar{
  margin-right: -100px;
  padding-right: 110px;
}
</style>



// WEBPACK FOOTER //
// src/components/openPlay.vue